module.exports = __webpack_public_path__ + "assets/img/title.ddc34890.png";